import { render, staticRenderFns } from "./multistage_table.vue?vue&type=template&id=5121d54d&scoped=true&"
import script from "./multistage_table.vue?vue&type=script&lang=js&"
export * from "./multistage_table.vue?vue&type=script&lang=js&"
import style0 from "./multistage_table.vue?vue&type=style&index=0&id=5121d54d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5121d54d",
  null
  
)

export default component.exports